import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router";
import { IsAuthorization } from "../../../../app";
import { IDetailKey } from "../../../../utils/common-type";
import { fakeClubServiceLog } from "../../../fake-data/backstage-management/system-log";
import { IAction, TemplateTable } from "../../../layout";
import Search from "./search";
import {
  defaultFilter,
  IClubServiceLog,
  IFilter,
  sortableColumns,
} from "./type";

const ClubServiceLog = () => {
  const auth = useContext(IsAuthorization);
  const [data] = useState<IClubServiceLog[]>(fakeClubServiceLog);
  const [filter, setFilter] = useState<IFilter>(defaultFilter());
  const [loading] = useState<boolean>(false);
  const [nextPageAvailable] = useState(false);
  const downloadData = useMemo(() => data, [data]);
  const { t } = useTranslation();
  const T = (name: string) => t(`ClubServiceLog.${name}`);

  const header: IDetailKey<IClubServiceLog>[] = [
    { key: "permission", name: T("permission") },
    { key: "time", name: T("time") },
    { key: "ip", name: T("ip") },
    { key: "username", name: T("username") },
  ];
  const action: IAction<IClubServiceLog> = {
    create: false,
    del: false,
    edit: false,
  };

  return !auth.login ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Search data={downloadData} filter={filter} setFilter={setFilter} />
      <TemplateTable<IClubServiceLog, IFilter>
        action={action}
        data={data}
        header={header}
        filter={filter}
        setFilter={setFilter}
        reloading={loading}
        sort={sortableColumns}
        toolbar={false}
        isNextPageHaveData={nextPageAvailable}
      />
    </>
  );
};

export default ClubServiceLog;
